import { c as _c } from "react/compiler-runtime";
import { EmptyPage } from "@components/common/empty-page/empty-page";
import { Button } from "@flat-ui";
import { useFilterQueryParams } from "@hooks/table-filters/use-filter-query-params";
import { SearchDuoIcon } from "@flat-ui";
import { useAppSelector } from "@store/store-helper";
import { tableTypeSelector } from "@store/table/table-selector";
import { TableType } from "@utils/track-event/track-event-list";
import { useMemo } from "react";

// TODO: Should be extended to show no data exist as well: https://faro01.atlassian.net/browse/ST-2197
/**
 * This component is shown when table is loaded and no data is provided.
 * This can be because no data exist, or because filters are applied and no data matches the filters.
 * Or even no data matches the search
 */
export function FaroTableEmptyPage() {
  const $ = _c(9);
  const tableType = useAppSelector(tableTypeSelector);
  const {
    clearAllFilters,
    quickFilter,
    isAnyFilterApplied
  } = useFilterQueryParams();
  let t0;
  bb0: {
    if (quickFilter && isAnyFilterApplied) {
      t0 = "Clear all";
      break bb0;
    }
    if (quickFilter) {
      t0 = "Clear search";
      break bb0;
    }
    if (isAnyFilterApplied) {
      t0 = "Clear filters";
      break bb0;
    }
    t0 = undefined;
  }
  const clearButtonText = t0;
  let t1;
  bb1: switch (tableType) {
    case TableType.projectMarkups:
      {
        t1 = "annotations";
        break bb1;
      }
    case TableType.snapshots:
      {
        t1 = "snapshots";
        break bb1;
      }
    default:
      {
        t1 = "results";
      }
  }
  const entityPlaceholder = t1;
  if (!tableType) {
    return null;
  }
  if (isAnyFilterApplied || quickFilter) {
    const t2 = `No matching ${entityPlaceholder} found`;
    let t3;
    if ($[0] !== clearAllFilters || $[1] !== tableType) {
      t3 = () => {
        clearAllFilters(tableType);
      };
      $[0] = clearAllFilters;
      $[1] = tableType;
      $[2] = t3;
    } else {
      t3 = $[2];
    }
    let t4;
    if ($[3] !== clearButtonText || $[4] !== t3) {
      t4 = <Button onClick={t3} variant="ghost">{clearButtonText}</Button>;
      $[3] = clearButtonText;
      $[4] = t3;
      $[5] = t4;
    } else {
      t4 = $[5];
    }
    let t5;
    if ($[6] !== t2 || $[7] !== t4) {
      t5 = <EmptyPage icon={SearchDuoIcon} title={t2} button={t4} />;
      $[6] = t2;
      $[7] = t4;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    return t5;
  }
  return null;
}